import { Component, Input, ViewChild, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ExportDataService } from '../../../../shared/services/export-data.service';
import { MaintenanceService } from '../../../services/maintenanceService';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { MatFormField } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../../shared/elements/loader/loader.component';
import { MaintenanceTableV4Component } from '../../maintenance-table-v4/maintenance-table-v4.component';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddEditForecastRoleManagementComponent } from '../forecast-role-management/add-edit-forecast-role-management/add-edit-forecast-role-management.component';

@Component({
    selector: 'app-forecast-segment-relationship',
    templateUrl: './forecast-segment-relationship.component.html',
    styleUrl: './forecast-segment-relationship.component.css',
    imports: [MatFormField, MatInput, FormsModule, LoaderComponent, MaintenanceTableV4Component, AppModalComponent, AddEditForecastRoleManagementComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ForecastSegmentRelationshipComponent implements OnInit {

  showLoader: boolean = false;
  @Input() segmentData: any = [];
  @ViewChild('addEditRoleManagement') addEditRoleManagement: any;
  oldDataSource: any = [];
  searchField: string = '';
  dataSourceDetails: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  isResetFilter: boolean = false;
  isTableRefreshed: boolean = false;

  TABLE_CONFIG: any = {
    pageSize: [10, 20, 30],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    commonEdit: true,
    commonEditLabel: 'Click to Edit',
    edit:false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    TABLE_CLASS: ''
  };

  TABLE_COLUMNS: any = [
    {
      key: 'Master_Segment',
      labelKey: "Master_Segment",
      label: 'Master Segment',
      filter: true,
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }]
    },
    {
      key: 'Users',
      labelKey: "Users",
      label: 'Users',
      filter: false,
      align: 'left',
      search: '',
      searchValue: '',
      edit: false,
      validations: [{ 'required': false }],
      padding: '5px 15px 5px 5px !important'
    }
  ];

  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  showModal: boolean = false;
  actionType: string = 'Add';
  editData: any = null;

  constructor(private maintenanceService: MaintenanceService, private toaster: ToastrService, private exportService: ExportDataService) { }

  ngOnInit(): void {
    this.initialiseData();
  }

  initialiseData() {
    this.showLoader = true;
    this.getTableData();
  }

  searchDataSet() {
    const data = this.searchTableData(this.oldDataSource, this.searchField);
    this.dataSourceDetails = new MatTableDataSource(data);
  }

  //Export the table data to excel
  exportToExcel() {
    const exportData = [];
    this.oldDataSource.forEach((val) => {
      val.Users.forEach((user: any) => {
        const exports = {};
        exports['Master Segment'] = val.Master_Segment;
        // exports['User Role'] = val.User_Role;
        exports['User Name'] = user.displayName;
        exports['Mail'] = user.mail;
        // exports['MSID'] = user.MSID;
        exportData.push(exports);
      })
    })
    this.exportService.exportToExcel('Infra Forecast Owner Access', [exportData], ['Forecast Owner Access']);
  }

    //Search the data based on the search text
    searchTableData(items: any[], searchText: string): any[] {
      if (!items) {
        return []
      }
      if (searchText) {
        this.isResetFilter = true;
      }else{
        this.isResetFilter = false;
        return items;
      }
      searchText = searchText.toLowerCase();
      return items.filter(item => this.filterItem(item, searchText));
    }


    filterItem(item: any, searchText: string): boolean {
      //searching based on Master Segment and User Role
      if (item.Master_Segment.toLowerCase().includes(searchText) || item.User_Role.toLowerCase().includes(searchText)) {
        return true;
      }
      //searching user data based on MSID, display name and mail
      return item.Users.some((user: any) => {
        return user.MSID.toLowerCase().includes(searchText) || user.displayName.toLowerCase().includes(searchText) || user.mail.toLowerCase().includes(searchText);
      })
    }

      onEditClick(data: any) {
        this.showModal = true;
        this.actionType = 'Edit';
        this.editData = _.cloneDeep(data);  
        this.openModal();
      }

      openModal() {
        this.addEditRoleManagement.show();
      }

      clearData(){
        this.actionType = '';
        this.editData = null;
        this.showModal = false;
      }

        //Refresh the table data after updation
    refreshTable(){
      this.closeModal();
      this.showModal = false;
      this.showLoader = false;
      this.actionType = 'Add';
      this.editData = null;
      this.maintenanceService.deleteCachedData('getForecastRoleManagementData');
      this.showLoader = true;
      this.getTableData();
      this.isTableRefreshed = true;
    }

      //Closing the modal
    closeModal() {
      this.addEditRoleManagement.hide();
    }

      //Get the data for list of forecast roles
    getTableData() {
      this.isResetFilter = false;
      this.maintenanceService.getForecastRoleManagementData().subscribe((data: any) => {
        this.handleTableData(data);
      }, (error) => {
        this.handleErrors(error);
      })
    }

      //Handle the errors while fetching the data
  handleErrors(error: any) {
    console.log(error);
    this.showLoader = false;
    this.toaster.error('Error While Fetching Data', '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

    //Handle the data received from the API
    handleTableData(data: any) {
      if (!data || data.length === 0) {
        this.dataSourceDetails = new MatTableDataSource([]);
        this.showLoader = false;
        return;
      }
      const filteredData = data.filter((val: any) => 
        val.Master_Segment !== "All" && val.User_Role === "SRM"
      );
      filteredData.forEach((val: any) => {
        val.Users = this.sortData(val.Users, 'displayName');
      });
      this.oldDataSource = filteredData;
      this.dataSourceDetails = new MatTableDataSource(filteredData);
      this.showLoader = false;
    }

      //Sort the data based on the key
  sortData(data: any[], key: string) {
    return data.sort((a, b) => {
      return a[key].localeCompare(b[key]);
    });
  }

}
